import { render, staticRenderFns } from "./imglist.vue?vue&type=template&id=43d23bfe&"
import script from "./imglist.vue?vue&type=script&lang=js&"
export * from "./imglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports